import { Component, OnInit } from '@angular/core';
import { LeadsService } from 'src/app/_service/leads.service';
import { MiscService } from 'src/app/_service/misc.service';
import { SharedService } from 'src/app/_service/shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DoctorService } from 'src/app/_service/doctor.service';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-add-edit-pincode',
  templateUrl: './add-edit-pincode.component.html',
  styleUrls: ['./add-edit-pincode.component.css']
})
export class AddEditPincodeComponent implements OnInit {
  pinCodeForm: FormGroup;
  submitted = false;
  loading: boolean = false;
  circles: any;
  zones_copy: any;
  zones: any;
  circles_copy: any;
  treatments: any;
  treatments_copy: any;
  pincodeId: any = '';
  diss_circle_city: boolean = false;
  constructor(private activatedRoute: ActivatedRoute, public miscapi: MiscService, public sharedapi: SharedService, public doctorapi: DoctorService, private leadapi: LeadsService, private formBuilder: FormBuilder, private router: Router) {
    let pincodePattern = "[0-9a-zA-Z]{6,}";
    this.pinCodeForm = this.formBuilder.group({
      'circle_id': [null, Validators.required],
      'zone_id': [null, Validators.required],
      'pin_code' : [null, Validators.compose([Validators.required, Validators.pattern(pincodePattern)])]
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['pincode_id']) {
        this.pincodeId = params['pincode_id'];
        this.patchPinCodeData(this.pincodeId);
      }
    });
  }
  ngOnInit(): void {
    this.getcircle();
  }

  get f() { return this.pinCodeForm.controls; }

  async createPinCode() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.pinCodeForm.invalid) {
      this.loading = false;
      return;
    }
    this.pincodeId = this.activatedRoute.snapshot.paramMap.get('pincode_id');
    this.pinCodeForm.value.id = parseInt(this.pincodeId);
    await this.miscapi.savePinCode(this.pinCodeForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.router.navigateByUrl('/master-pin-code-list');
        this.pinCodeForm.reset();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getCircleZone(circle_id) {
    let qString = 'circle=' + circle_id;
    await this.miscapi.getCircle_zone(qString).subscribe((data: any) => {
      if (data.status) {
        this.zones = data.data;
        this.zones_copy = this.zones;
      } else {
        this.zones = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'zones') {
      this.zones = this.sharedapi.searchData(searchtText, this.zones_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'zone') {
      $("#zoneSearch").val('');
      $("#zoneSearch").focus();
      this.zones = this.zones_copy;
    }
  }

  async patchPinCodeData(pincodeId) {
    await this.miscapi.getPinCodeEditData(this.pincodeId).subscribe((response: any) => {
      if (response.status) {
        this.getCircleZone(response.data.circle_id);
        this.diss_circle_city = true;
        this.pinCodeForm.patchValue({
          'circle_id': response.data.circle_id,
          'zone_id': response.data.zone_id,
          'pin_code': response.data.pincode
        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

}
